<script>
import FormWrapper from "../ui/forms/FormWrapper";
import FormControl from "../ui/forms/FormControl";
import FormLabel from "../ui/forms/FormLabel";
import UiInput from "../ui/forms/UiInput";
import Textarea from "../ui/forms/Textarea";
import FormHelper from "../ui/forms/FormHelper";

export default {
  name: "WatchmanForm",
  components: {
    FormWrapper,
    FormControl,
    FormLabel,
    UiInput,
    Textarea,
    FormHelper,
},
  props: {
    value: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      watchman: {
        ...this.value,
        name: this.value.name && !this.value.system_name ? this.value.name : "",
        description: this.value.description || "",
      }
    };
  },
  methods: {
    listProcedures: function (array) {
      const procedures = []
      array.forEach( channel => {
        channel.rmProcedures.forEach( procedure => {
          procedures.push({id: procedure.id, name: procedure.name})
        })
      })
      return [...new Set(procedures)]
    }
  },
  computed: {
    proceduresCount() {
      if (!this.watchman.channels) {
        return 0;
      }
      return this.listProcedures(this.watchman.channels).length
    }
  },
  watch: {
    watchman: {
      handler(newValue) {
        this.$emit('input', newValue);
      },
      deep: true
    }
  }
};
</script>

<template>
  <FormWrapper>
    <FormControl>
      <FormLabel>{{ $t("watchmen.form.name") }}</FormLabel>
      <UiInput 
        v-model="watchman.name" 
        :disabled="!!proceduresCount" 
        :placeholder="$t('watchmen.form.name_placeholder')"
      />
      <div 
        v-if="!!proceduresCount"
        class="alert alert-info d-flex align-items-center mb-0 py-2" 
        role="alert"
      >
        <i aria-hidden="true" class="fa fa-lock fa-lg mr-3"></i>
        <div>{{ $t("watchmen.form.errors.procedures_no_edit") }}</div>
      </div>
    </FormControl>
    <FormControl>
      <FormLabel>{{ $t("watchmen.form.description") }}</FormLabel>
      <Textarea v-model="watchman.description" />
    </FormControl>
  </FormWrapper>
</template>
